// import React from "react";
import "./BlackberryFooter.scss";
import {
  FaFacebookF,
  FaPinterest,
  FaInstagram,
  FaLinkedinIn,
  FaGoogle,
  FaLock
} from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const BlackberryFooter = () => {
  return (
    <footer className="bb-footer">

      <div className="bb-footer-top">
        <div className="bb-footer-top-left">
          <img src="/assets/img/elnora/footerlogo.png" alt="Elnora" />
          <p>
            Elnora Stay In Trend is a fashion brand that blends elegance with modern trends, offering timeless styles designed to keep you confident, stylish, and always in vogue
          </p>
        </div>
        <div className="bb-footer-top-right">
          <h3>Follow Us On</h3>
          <div className="bb-footer-social-links">
            <a href="https://m.facebook.com/profile.php?id=61556295383366" target="__blank" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://pin.it/j2H0MMoPy" target="__blank" aria-label="Pinterest">
              <FaPinterest />
            </a>
            <a href="https://www.instagram.com/elnorastayintrend?igsh=MXE3ZTA2enpxMGdyNA==" target="__blank" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/in/elnora-stay-in-trend-162a81320" target="__blank" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>

            <a href="https://share.google/bN0MskTFsG76KNqgz" target="__blank" aria-label="Google">
              <FaGoogle />
            </a>
          </div>
        </div>
      </div>

      <div className="bb-footer-content">
        <div className="bb-footer-section quick-links">
          <h4>Categories</h4>
          <ul>
            <li>
              <a href="#">Party Wear</a>
            </li>
            <li>
              <a href="#">Casual Wear</a>
            </li>
            <li>
              <a href="#">Indo Western</a>
            </li>
            <li>
              <a href="#">Festive Wear</a>
            </li>
            <li>
              <a href="#">Wedding Wear</a>
            </li>
            <li>
              <a href="#">Lehengas</a>
            </li>
          </ul>
        </div>

        {/* Quick Links Section */}
        <div className="bb-footer-section quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="#">Home</a>
            </li>
            <li>
              <a href="#">Collection</a>
            </li>
            <li>
              <a href="#">About Us</a>
            </li>
            <li>
              <a href="#">Contact</a>
            </li>
            <li>
              <a href="#">Stores</a>
            </li>
          </ul>
        </div>

        {/* Customer Service Section */}
        <div className="bb-footer-section customer-service">
          <h4>Customer Service</h4>
          <ul>
            <li>
              <a href="#">FAQ</a>
            </li>
            <li>
              <a href="#">Shipping Policy</a>
            </li>
            <li>
              <a href="#">Return Policy</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
            <li>
              <a href="#">Terms & Conditions</a>
            </li>
          </ul>
        </div>

        {/* Contact Info Section */}
        <div className="bb-footer-section contact-info">
          <h4>Contact Us</h4>
          <div className="contact-details">
            <div className="contact-item">
              <MdLocationOn />
              <p>Plot No. 11, Block F-2, Sector 11, Rohini, Delhi, 110085</p>
            </div>
            <div className="contact-item">
              <MdPhone />
              <p>011 4106 1619</p>
            </div>
            <div className="contact-item">
              <MdEmail />
              <p>elnorastayintrend@gmail.com</p>
            </div>
          </div>
        </div>
      </div>

      {/* accept payment methods section */}
      <div className="bb-footer-payment-methods">
        <h5> 
          <span class="material-symbols-outlined">
          beenhere
        </span> 
        100% Secure Payment Methods
        </h5>
      </div>

      {/* Copyright Section */}
      <div className="bb-footer-bottom">
        <p>&copy; {new Date().getFullYear()} Elnora. All rights reserved.</p>
        <p>Powered by <a href="https://www.hyperclouddigital.com" target="__blank">HyperCloud Digital Solutions</a></p>
      </div>
    </footer>
  );
};

export default BlackberryFooter;
